module.exports = __webpack_public_path__ + "img/11.6fccb1ff.png";